import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedUiModule } from '@g99-product-web-ui/shared-ui';
import { QRCodeComponent } from 'angularx-qrcode';

import { AuthAdditionalOptionFooterComponent } from './components/auth-additional-option-footer/auth-additional-option-footer.component';
import { AuthContainerComponent } from './components/auth-container/auth-container.component';
import { BusinessLoginComponent } from './components/business-selection/business-selection.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { MfaSetupComponent } from './components/mfa-setup/mfa-setup.component';
import { MfaVerifyComponent } from './components/mfa-verify/mfa-verify.component';
import { RedirectFromOldUiComponent } from './components/redirect-from-old-ui/redirect-from-old-ui.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SupportLoginComponent } from './components/support-login/support-login.component';
import { TotpSetupComponent } from './components/totp-setup/totp-setup.component';
import { coreLibRoutes } from './core-lib.routes';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(coreLibRoutes),
    ReactiveFormsModule,
    SharedUiModule,
    QRCodeComponent,
  ],
  declarations: [
    SignInComponent,
    BusinessLoginComponent,
    MfaSetupComponent,
    MfaVerifyComponent,
    SupportLoginComponent,
    TotpSetupComponent,
    AuthContainerComponent,
    AuthAdditionalOptionFooterComponent,
    RedirectFromOldUiComponent,
    ForgetPasswordComponent,
  ],
  exports: [SignInComponent],
})
export class CoreLibModule {}
